/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-direction:column;height:100%;width:100%}.scrollview-container[_ngcontent-%COMP%]{padding-top:2px;padding-bottom:2px}.welcome-message-container[_ngcontent-%COMP%]{display:block;width:100%;margin-top:5px;margin-bottom:10px;padding-right:20px;padding-left:20px;font-weight:400;max-height:160px;white-space:normal!important}.welcome-message-container[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{margin-top:10px}.emphasis[_ngcontent-%COMP%]{font-weight:900}"];
export { styles as styles };
